<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <template #handle>
        <el-form-item>
          <el-button v-show="authList.includes('user:export')" v-if="!standard" type="primary" plain @click="exportData">{{$t('points.exchange.exportTable')}}</el-button>
          <el-button v-show="authList.includes('user:add')" type="primary" plain @click="addUser">{{$t('system.user.createUser')}}</el-button>
        </el-form-item>
      </template>
    </Filter>
    <Table ref="tableRef" :tableData="tableDataList" :total="data.total" @update="updatePage" @sort-change="handleSortChange">
      <el-table-column prop="registerTime" :label="$t('points.referrer.registrationTime')" />
      <el-table-column prop="userName" :label="$t('activity.points.name')" />
      <el-table-column prop="userType" :label="$t('points.exchange.status')" >
        <template #default="{row}">
          {{ userStatusMap[row.userType] }}
        </template>
      </el-table-column>
      <el-table-column prop="userLabel" :label="$t('points.detail.userTag')" >
        <template #default="{row}">
          {{ row.userLabel?.map(item => userTypesMap[item]).join(', ') || $t('points.detail.regularUser') }}
        </template>
      </el-table-column>
      <el-table-column prop="phoneNumber" :label="$t('other.visitor.phone')" >
        <template #default="{row}">
          {{ row.phoneNumber &&  (String(row.phoneNumber).slice(0,3)+'****'+String(row.phoneNumber).slice(7))}}
        </template>
      </el-table-column>
      <el-table-column prop="email" :label="$t('activity.sale.email')" />
      <el-table-column prop="company" :label="$t('activity.sale.company')" />
      <el-table-column prop="userCompany" :label="$t('system.user.region')" >
        <template #default="{row}">{{ row.userCompany && `${row.userCompany.province??''}${row.userCompany.city??''}${row.userCompany.district??''}`  }}</template>
      </el-table-column>
      <el-table-column prop="userCompany" :label="$t('system.user.address')" >
        <template #default="{row}">{{ row.userCompany ? row.userCompany.address : '' }}</template>
      </el-table-column>
      <el-table-column prop="industryName" :label="$t('service.virtual.industry')" />
      <el-table-column prop="registerWay" :label="$t('banner.list.sourceChannel')">
        <template #default="{row}">{{ registerWayMap[row.registerWay] }}</template>
      </el-table-column>
      <el-table-column prop="role" :label="$t('system.role.role')" >
        <template #default="{row}">{{(row.role||[]).map((item)=>{return item.roleName}).join('，')}}</template>
      </el-table-column>
      <el-table-column prop="lastLoginTime" :label="$t('system.user.recentLogin')" sortable="custom"/>
      <el-table-column prop="loginCount" :label="$t('system.user.accessCount')" sortable="custom"/>
      <el-table-column :label="$t('activity.list.operation')" fixed="right" :width="curLang == 'zh-CN' ? '150px' : '200px'">
        <template #default="{row}">
          <!-- v-if="row.registerWay == 2" 放开所有渠道都可以重置密码-->
          <el-button v-show="authList.includes('user:resetPass')" style="margin-left: 0px; margin-right: 10px;" type="text" size="mini" @click="()=> { 
            data.dialogPassword = true
            passwordForm.userId = row.id
          }">{{$t('system.user.resetPassword')}}</el-button>
          <el-button v-show="authList.includes('user:proxyLogin')" style="margin-left: 0px; margin-right: 10px;" :disabled="!row.phoneNumber" type="text" size="mini" @click="proxyLogin(row)">{{$t('system.user.proxyLogin')}}</el-button>
          <el-button v-show="authList.includes('user:setRole')" style="margin-left: 0px; margin-right: 10px;" type="text" size="mini" @click="editRole(row)">{{$t('system.user.modifyRole')}}</el-button>
          <el-button v-show="authList.includes('user:forbid')" v-if="row.userType == 1" type="text" style="color: #f56c6c; margin-left: 0px; margin-right: 10px;" size="mini" @click="disableDetail(row)">{{$t('system.user.disable')}}</el-button>
          <el-button v-if="row.userType == 100" type="text" size="mini" @click="enableDetail(row)">{{$t('system.user.enable')}}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="$t('system.user.modifyRole')" v-model="data.dialogRoleVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="form" class="dialog-form" :model="roleForm" label-width="100px">
        <el-form-item :label="$t('system.user.roleColon')">
          <el-select
            v-model="roleForm.roleId"
            :placeholder="$t('system.role.role')"
            multiple
            clearable
            style="width:100%;"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('system.user.tagColon')">
          <el-select
            v-model="roleForm.userLabel"
            :placeholder="$t('service.clue.tag')"
            clearable
            multiple
            style="width:100%;"
          >
            <el-option
              v-for="item in userTypesList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="onRoleSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="$t('system.user.createUser')" v-model="data.dialogAddUserVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="userFormRef" class="dialog-form" :model="userForm" :rules="userFormRules" :label-width="curLang == 'zh-CN' ? '100px' : '150px'">
        <el-form-item :label="$t('activity.packetjoin.name')" prop="userName">
          <el-input :placeholder="$t('system.user.enterName')" v-model="userForm.userName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.user.phoneNumberColon')" prop="phoneNumber">
          <el-input :placeholder="$t('points.record.pleaseEnterPhoneNumber')" v-model="userForm.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.user.emailColon')" prop="email">
          <el-input :placeholder="$t('system.user.enterEmail')" v-model="userForm.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.user.newPasswordColon')" prop="password">
          <el-input :placeholder="$t('system.user.enterNewPassword')" v-model="userForm.password" type="password" autocomplete="new-password" show-password  @input="checkCustomStrength">
          </el-input>
        </el-form-item>
        <el-form-item v-if="userForm.password">
          <div class="strength-meter">
            <div class="strength-fill" :style="customStrengthStyle"></div>
          </div>
          <!-- <div class="strength-labels">
            <span>非常弱</span>
            <span>弱</span>
            <span>一般</span>
            <span>强</span>
            <span>非常强</span>
          </div> -->
          <!-- <div class="strength-text" :style="{color: customStrengthColor}">
            {{ customStrengthText }}
          </div> -->
        </el-form-item> 
        <el-form-item :label="$t('system.user.confirmPasswordColon')" prop="confirmPass">
          <el-input :placeholder="$t('system.user.reEnterNewPassword')" v-model="userForm.confirmPass" show-password>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="" style="color: #D80C1E;">{{$t('system.user.passwordRequirement')}}</el-form-item> -->
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="onUserSubmit(0)">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <Dialog :dialogOpen="data.dialogPassword" :params="{userId: passwordForm.userId}" @close="closeDialog" @submit="submitDialog"></Dialog>
    <!-- <el-dialog :title="$t('system.user.changePassword')" v-model="data.dialogPassword" :modal="true" :append-to-body="true">
      <el-form ref="passwordFormRef" class="dialog-form" :model="passwordForm" :rules="passwordFormRules" :label-width="curLang == 'zh-CN' ? '100px' : '150px'">
        <el-form-item label="userId：" prop="userId">
          <el-input placeholder="请输入新密码" v-model="passwordForm.userId">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('system.user.newPasswordColon')" prop="password">
          <el-input :placeholder="$t('system.user.enterNewPassword')" v-model="passwordForm.password" show-password>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('system.user.confirmPasswordColon')" prop="confirmPass">
          <el-input :placeholder="$t('system.user.reEnterNewPassword')" v-model="passwordForm.confirmPass" show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="" style="color: #D80C1E;">{{$t('system.user.passwordRequirement')}}</el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="mini" @click="onUserSubmit(1)">{{$t('activity.list.confirm')}}</el-button>
        </span>
      </template>
    </el-dialog> -->
  </div>
</template>

<script>
import { request, downloadFile } from "@/utils/request";
import { common } from "@/common/mixin";
import { ElMessage, ElMessageBox } from "element-plus";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ref, reactive, toRefs, computed } from "vue";
import { userTypesList, userTypesMap, userStatusList, userStatusMap, registerWayList, registerWayMap } from "@/common/constant";
import { useRouter } from 'vue-router'
import {  checkNumberForm, checkEmailForm, validatePassword } from '@/utils/formValidate.js'
import { standard } from '@/common/constant';
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex"
import Dialog from '@/components/dialog/index'
export default {
  components: {
    Table,
    Filter,
    Dialog
  },
  mixins: [common],
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const state = reactive({
      userFormRef: null,
      passwordFormRef: null,
      standard: standard,
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList')),
      tableRef: null
    })
    const router = useRouter()
    const params = [
      {
        key: "userName",
        value: "",
        label: t('activity.points.name'),
      },
      {
        key: "phoneNumber",
        value: "",
        label: t('other.visitor.phone'),
      },
      {
        key: "userType",
        type: 'Select',
        value: '',
        label: t('system.user.userStatus'),
        options: {
          data: userStatusList,
          label: 'name',
          value: 'value',
        },
      },
      {
        key: "userLabel",
        type: 'Select',
        value: '',
        label: t('points.detail.userTag'),
        options: {
          data: userTypesList,
          label: 'name',
          value: 'value',
        },
        attrs: {
          multiple: false
        }
      },
      {
        key: "registerWay",
        type: 'Select',
        value: '',
        label: t('banner.list.sourceChannel'),
        options: {
          data: registerWayList,
          label: 'name',
          value: 'value',
        },
      },
      {
        type: "Date",
        key: "startTime",
        value: '',
        label: t('activity.list.startDate'),
        options: {
          "type": "date",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "placeholder": t('activity.list.startDate'),
        }
      },
      {
        type: "Date",
        key: "endTime",
        value: '',
        label: t('activity.list.endDate'),
        options: {
          "type": "date",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "placeholder": t('activity.list.endDate'),
          "default-time": new Date(2000, 1, 1, 23, 59, 59)
        }
      },
    ];
    const form = reactive({
        userName: "",
        role: "",
        phoneNumber: "",
        email: "",
        company: "",
    })
    var query = {
      userName: "", // 姓名
      phoneNumber: "", // 电话
      // role: "", // 角色
    };
    const roleForm = reactive({
      userId: '',
      roleId: [],
      userLabel: [],
    });
    const userForm = reactive({
      userName: '',
      phoneNumber: '',
      email: '',
      password: '',
      confirmPass: ''
    });
    const userFormRules = reactive({
      userName: {
        required: true,
        message: t('system.user.enterName'),
        trigger: 'blur'
      },
      phoneNumber: [{
        required: true,
        message: t('points.record.pleaseEnterPhoneNumber'),
        trigger: 'change'
      },
      {
        validator: checkNumberForm,
        message: t('system.user.invalidPhoneFormat'),
        trigger: 'blur',
      }],
      email: [{
          required: true,
          message: t('system.user.enterEmail'),
          trigger: 'change'
        },
        {
          validator: checkEmailForm,
          message: t('system.user.invalidEmailFormat'),
          trigger: 'blur',
      }],
      // password: [{
      //     required: true,
      //     message: t('system.user.enterNewPassword'),
      //     trigger: 'change'
      //   },
      //   {
      //     validator: validatePassword,
      //     trigger: 'blur',
      //   }
      // ],
      password: {
        required: true,
        message: t('system.user.enterNewPassword'),
        trigger: 'change'
      },
      confirmPass: {
        required: true,
        message: t('system.user.reEnterNewPassword'),
        trigger: 'change'
      },
    })

    const passwordForm = reactive({
      password: '',
      confirmPass: '',
      userId: null,
    });   
    const passwordFormRules = reactive({
      password: [{
          required: true,
          message: t('system.user.enterNewPassword'),
          trigger: 'change'
        },
        {
          validator: validatePassword,
          trigger: 'blur',
        }
      ],
      // password: {
      //   required: true,
      //   message: t('system.user.enterNewPassword'),
      //   trigger: 'change'
      // },
      confirmPass: {
        required: true,
        message: t('system.user.reEnterNewPassword'),
        trigger: 'change'
      },
    })
    const data = reactive({
      dialogRoleVisible: false,
      dialogAddUserVisible: false,
      dialogPassword: false,
      page: 1,
      size: 10,
      total: 0,
    });
    const tableDataList = ref([])
    const roleList =  ref([])
    const customStrength = ref(0)
    // 计算属性
    const hasUpperCase = computed(() => {
      return /[A-Z]/.test(userForm.password)
    })
    
    const hasLowerCase = computed(() => {
      return /[a-z]/.test(userForm.password)
    })
    
    const hasNumber = computed(() => {
      return /[0-9]/.test(userForm.password)
    })
    
    const hasSpecialChar = computed(() => {
      return /[!@#$%^&*]/.test(userForm.password)
    })
    const customStrengthStyle = computed(() => {
      const width = (customStrength.value / 4) * 100
      return {
        width: `${width}%`,
        backgroundColor: customStrengthColor.value
      }
    })

    const customStrengthColor = computed(() => {
      const colors = ['#F56C6C', '#E6A23C', '#409EFF', '#67C23A', '#67C23A'];
      return colors[customStrength.value];
    })

    const customStrengthText = computed(() => {
      const texts = ['非常弱', '弱', '一般', '强', '非常强'];
      return userForm.password ? texts[customStrength.value] : '未输入'
    })

    const getData = async () => {
      console.log("query", query)
      try {
        const res = await request("getUserList", {
          ...query,
          ...state.sortData,
          page: data.page,
          size: data.size,
        });
        console.log("getUserList", res);
        tableDataList.value = res.records;
        data.total = res.total;
      } catch (error) {
        console.error(error);
      }
    }
    const exportData = async () => {
      try {
        const res = await downloadFile("exportUserList", {}, {
          method: 'GET',
          params: query
        });
        // let blob = new Blob([res],{type: "application/octet-stream"})
        let reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = t('system.user.userListExcel')
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    }
    const addUser = async () => {
      data.dialogAddUserVisible = true
      // try {
      //   const res = await downloadFile("exportUserList", {}, {
      //     method: 'GET',
      //     params: query
      //   });
      //   // let blob = new Blob([res],{type: "application/octet-stream"})
      //   let reader = new FileReader();
      //   reader.readAsDataURL(res);
      //   reader.onload = (e) => {
      //     const a = document.createElement('a')
      //     a.download = '用户列表.xlsx'
      //     a.href = e.target.result
      //     a.click()
      //   }
      // } catch (error) {
      //   console.error(error)
      // }
    }
    const getRoleList = async () => {
      try {
        const res = await request("getRoleList", {
          page: 1,
          size: 9999,
        })
        roleList.value = res.records
      } catch (error) {
        console.error(error)
      }
    }
    const searchData = (data) => {
      query = data;
      getData();
    };
    const updatePage = (page, size) => {
      data.page = page || 1;
      data.size = size || 10;
      getData();
    };
    const handleSortChange = ({column, prop, order}) => {
      // ascending descending null
      console.log('onSortChange', column, prop, order)
      // context.emit('sort-change', {column, prop, order})
      const orderMap = { ascending: 'asc', descending: 'desc' }
      state.sortData = {
        sortField: prop,
        sort: orderMap[order]
      }
      getData()
    }
    const disableDetail = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('system.user.confirmDisable'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning',
          }
        )
        await request('setInvalidUser', {
          id: row.id,
          userType: 100
        })
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const enableDetail = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('system.user.confirmEnable'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning',
          }
        )
        await request('setInvalidUser', {
          id: row.id,
          userType: 1
        })
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const proxyLogin = async (row) => {
      request('proxyLogin', {
        phoneNumber: row.phoneNumber,
      })
      .then((data) => {
        if (data.token) {
          window.localStorage.setItem('userName', data.userName)
          // this.savePass && window.localStorage.setItem('password', this.password)
          // !this.savePass && window.localStorage.removeItem('password')
          window.localStorage.setItem('token', data.token)

          window.localStorage.setItem('userInfo', JSON.stringify(data||{}))
          router.push({ path: '/' })
          location.reload()
        }
      })
      .catch((error) => {
        // ElMessage({
        //   showClose: true,
        //   type: "error",
        //   message: error || t('system.user.loginFailed'),
        //   duration: 3 * 1000
        // })
      })
    };
    const editRole = async (row) => {
      try {
        console.log("editRole", row);
        roleForm.userId = row.id
        roleForm.roleId = (row.role||[]).map((item)=>{
          return item.roleId
        })
        roleForm.userLabel = row.userLabel || [0]
        data.dialogRoleVisible = true
      } catch (error) {
        console.error(error);
      }
    };
    const onRoleSubmit = async function () {
      try {
        await request("setUserRole", roleForm)
        data.dialogRoleVisible = false
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.user.roleModifySuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const onUserSubmit = async (type)=> {
      if(type){
        state.passwordFormRef && await state.passwordFormRef.validate()
        try {
          if (passwordForm.password !== passwordForm.confirmPass) {
            ElMessage({
              showClose: true,
              type: "warning",
              message: t('system.user.passwordMismatch')
            })
            return
          } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*?]{8,64}$/.test(passwordForm.password)) {
            ElMessage({
              showClose: true,
              type: "warning",
              message: t('system.user.passwordNotMeetRequirements')
            })
            return
          }
          await request('changePass', passwordForm)
          ElMessage({
            showClose: true,
            type: "success",
            message: t('system.user.passwordChangeSuccess')
          })
          passwordForm.password = ''
          passwordForm.confirmPass = ''
          data.dialogPassword = false
          getData()
      } catch (error) {
        console.error(error)
      }
      }else{
        state.userFormRef && await state.userFormRef.validate()
        
        try {
          if (userForm.password !== userForm.confirmPass) {
            ElMessage({
              showClose: true,
              type: "warning",
              message: t('system.user.passwordMismatch')
            })
            return
          } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*?]{8,64}$/.test(userForm.password)) {
            ElMessage({
              showClose: true,
              type: "warning",
              message: t('system.user.passwordNotMeetRequirements')
            })
            return
          }
          await request("addUser", userForm)
          data.dialogAddUserVisible = false
          getData()
          ElMessage({
            showClose: true,
            type: "success",
            message: t('system.user.passwordChangeSuccess')
          })
        } catch (error) {
          console.error(error)
        }
      }
    }

    // 自定义强度检查
    const checkCustomStrength = () => {
      if (!userForm.password) {
        customStrength.value = 0;
        return;
      }
      
      let strength = 0;
      
      // 长度检查
      if (userForm.password.length >= 8) strength++;
      if (userForm.password.length >= 12) strength++;
      
      // 字符种类检查
      if (hasUpperCase.value && hasLowerCase.value) strength++;
      if (hasNumber.value) strength++;
      if (hasSpecialChar.value) strength++;
      
      // 限制最大强度为4
      customStrength.value = Math.min(strength, 4);
    }

    const closeDialog = () => {
      data.dialogPassword = false
    }
    const submitDialog = () => {
      data.dialogPassword = false
      getData()
    }

    getData()
    getRoleList()
    return {
      ...toRefs(state),
      userTypesList,
      userTypesMap,
      userStatusMap,
      registerWayMap,
      params,
      query,
      data,
      tableDataList,
      roleList,
      form,
      roleForm,
      userForm,
      userFormRules,
      passwordFormRules,
      passwordForm,
      hasUpperCase,
      hasLowerCase,
      hasNumber,
      hasSpecialChar,
      customStrengthStyle,
      customStrengthColor,
      customStrengthText,
      disableDetail,
      enableDetail,
      proxyLogin,
      editRole,
      getData,
      exportData,
      addUser,
      searchData,
      updatePage,
      handleSortChange,
      onRoleSubmit,
      onUserSubmit,
      checkCustomStrength,
      closeDialog,
      submitDialog
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.strength-meter {
  height: 10px;
  background: #eee;
  border-radius: 5px;
  margin: 10px 0;
  overflow: hidden;
  max-width: 500px;
}
.strength-fill {
  height: 100%;
  width: 0%;
  transition: width 0.3s ease;
  border-radius: 5px;
}
.strength-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  font-size: 12px;
  color: #909399;
  max-width: 500px;
}
.strength-text {
  text-align: right;
  font-weight: bold;
  margin-top: 5px;
}
</style>
